module.exports = __webpack_public_path__ + "img/event-soiree-fusion-10-2024.241ee0d.jpg";